























import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { GrowingPurpose } from '@/models/student/growing-purpose';
import { SchoolGroupPMAnalysis } from '@/models/school-group/school-group-pm-analysis';
import { masterModule } from '@/store/modules/entities/master.module';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GPmAnalysisChart from '@/views/GClassManagement/GPmAnalysisChart.vue';

@Component({
  name: 'GClassManagementPmAnalysis',
  components: {
    GPmAnalysisChart,
  },
})
export default class GClassManagementPmAnalysis extends mixins(GPageBase) {
  mounted() {
    this.currentGrowingPurposeID = 1;
  }

  get growingPurposes(): GrowingPurpose[] {
    if (this.isDispCtrlTypeUchida) {
      return masterModule.growingPurposes.filter((gp: GrowingPurpose) => {
        if (gp.growingPurposeID == GEnum.GrowingPurpose.LeaderShip) return gp;
      });
    } else {
      return masterModule.growingPurposes;
    }
  }

  get currentGrowingPurposeID(): number {
    return statisticsModule.currentGrowingPurposeID;
  }

  set currentGrowingPurposeID(value: number) {
    statisticsModule.setCurrentGrowingPurposeID(value);
  }

  get schoolGroupPMAnalysis(): SchoolGroupPMAnalysis {
    return statisticsModule.schoolGroupPMAnalysisByGrowingPurposeID;
  }

  get pmAnalysisChartKey(): string {
    if (this.schoolGroupPMAnalysis) {
      return JSON.stringify(this.schoolGroupPMAnalysis);
    }
  }

  /**
   * 内田洋行タイプ
   */
  get isDispCtrlTypeUchida(): boolean {
    return this.$store.state.account.dispCtrlType === GEnum.DispCtrlType.Uchida;
  }
}
